import React from "react";
import "./Resume.css"

const skills = [
  { name: "HTML5", percent: "90%" },
  { name: "CSS3", percent: "80%" },
  { name: "JavaScript", percent: "85%" },
  { name: "React.Js", percent: "70%" },
  { name: "Node.Js", percent: "70%" },
  { name: "Express.Js", percent: "75%" },
  { name: "MySQL, MongoDB", percent: "60%" },
  { name: "Problem Solving", percent: "70%" },
];

const Resume = () => {
  return (
    <div
      id="resume"
      className="resume-details mt-5 d-flex justify-content-center text-link-color"
    >
      <div className="">
        <div className=" d-flex justify-content-center">
          <div className="row">
            <div className="">
              <h2 class="text-center">Resume</h2>
              <hr className="horizantel-line" />
            </div>
            {skills.map((skill) => (
              <div className="col-md-6 col-sm-12">
                <div className="p-3">
                  <h5>
                    {skill.name} - {skill.percent}
                  </h5>
                  <div class="progress">
                    <div
                      class="progress-bar progress-bar-striped progress-bar-animated pbarColor"
                      role="progressbar"
                      style={{ width: `${skill.percent}` }}
                    ></div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Resume;
